/**
 * @typedef {import('./types').Arrival} Arrival
 */

/**
 * @param {Arrival} arrival
 */
export const getArrivalKey = (arrival) =>
    arrival.id ||
    `${arrival.vehicle || 'unknown'}|${arrival.headsign || 'unknown'}|${arrival.arrivalTimestamp || ''}|${Math.round(arrival.minutes * 10)}`;

/**
 * @param {Arrival[]} base
 * @param {Arrival[]} extended
 * @param {number} [maxCount]
 */
export const buildDisplayArrivals = (base, extended, maxCount = 4) => {
    /** @type {Map<string, Arrival>} */
    const byKey = new Map();
    [...base, ...extended].forEach((arrival) => {
        const key = getArrivalKey(arrival);
        if (!byKey.has(key)) {
            byKey.set(key, arrival);
        }
    });

    const uniqueArrivals = Array.from(byKey.values());
    const live = uniqueArrivals
        .filter((arrival) => !!arrival.isRealtime)
        .sort((a, b) => a.minutes - b.minutes);
    const scheduled = uniqueArrivals
        .filter((arrival) => !arrival.isRealtime)
        .sort((a, b) => a.minutes - b.minutes);

    return [...live, ...scheduled].slice(0, maxCount);
};
